export default __webpack_public_path__ + "static/media/stc-odb-logo.151d37ee.svg";